import axios from '@/utils/axios';

const deleteSource = (accountId, accountSourceId) => axios.delete(`/sources/${accountId}/${accountSourceId}`);
const disableSource = (accountId, accountSourceId) => axios.patch(`/sources/${accountId}/${accountSourceId}/disable`);
const enableSource = (accountId, accountSourceId) => axios.patch(`/sources/${accountId}/${accountSourceId}/enable`);
const getSource = (accountId, accountSourceId) => axios.get(`/sources/${accountId}/${accountSourceId}`);
const createSource = (accountId, name, type, detail, frequency, anchorTime, startDate, destinations, timezone) => axios.post(`/sources/${accountId}/`, {
  name,
  type,
  detail,
  frequency,
  anchorTime,
  startDate,
  destinations,
  timezone,
});
const updateSource = (accountId, accountSourceId, name, detail, frequency, anchorTime, destinations, pullHistory, historicalDate, timezone) => axios.patch(`/sources/${accountId}/${accountSourceId}/`, {
  name,
  detail,
  frequency,
  anchorTime,
  destinations,
  pullHistory,
  historicalDate,
  timezone,
});
const deleteData = (accountId) => axios.delete(`/sources/deleteData/${accountId}`);

export default {
  deleteSource,
  disableSource,
  enableSource,
  getSource,
  createSource,
  updateSource,
  deleteData,
};
